import { render, staticRenderFns } from "./DonutChart03.vue?vue&type=template&id=37c503b2&scoped=true"
import script from "./DonutChart03.vue?vue&type=script&lang=js"
export * from "./DonutChart03.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c503b2",
  null
  
)

export default component.exports